<template>
    <div class="flash">
      <b-container>
        <b-row>
          <b-col sm="12" lg="6">
            <h4 class="flash__title mb-4">Ottieni il tuo Buono sconto con la promozione</h4>
            <div class="flash__logos">
              <img alt="VadoBay Livebooking" src="assets/brands/livebooking.svg" />
              <span>per</span>
              <img alt="Luxottica" src="assets/luxottica-logo.svg" />
            </div>
            <div class="flash__content">
              <p class="flash__content-title">Come richiedere il Buono e come usarlo</p>
              <ul class="flash__content-list flash__content-list--decimal">
                <li>compila il form in questa pagina</li>
                <li>controlla il ricevimento del Buono all’indirizzo email che hai inserito</li>
                <li>fai login sul sito inserendo il Buono sconto sulla pagina web indicata nell’email</li>
                <li>cerca e scegli il tuo viaggio</li>
              </ul>
              <p class="flash__content-title">Troverai lo sconto già applicato una volta arrivato nella pagina di checkout.</p>
              <p class="flash__content-title">Condizioni d'uso specifiche</p>
              <ul class="flash__content-list flash__content-list--disc">
                <li>Con il Buono sconto potrai scoprire e provare i nostri servizi ma non potrai usarlo insieme al tuo credito welfare: eventuali integrazioni andranno fatte con la carta di credito.</li>
                <li>il Buono VadoBay livebooking prevede un minimo di spesa pari a 300 €</li>
                <li>il Buono vacanze by VadoBay prevede un minimo di spesa di 1000 €</li>
                <li>lo stesso utente può richiedere online, in un'unica richiesta o in richieste successive, sia un Buono di tipo VadoBay livebooking sia un Buono di tipo vacanze by VadoBay</li>
                <li>il massimo di Buoni di ciascun tipo che possono essere richiesti è 1</li>
                <li>i Buoni non sono cumulabili con altri Buoni VadoBay</li>
                <li>i Buoni sono validi per partenze entro il 31-12-2025</li>
              </ul>
            </div>
          </b-col>
          <b-col sm="12" lg="6" class="d-flex justify-content-center">
            <b-form-group :state="validateFields()">
              <div class="flash__form">
                <h6 class="black text-center mb-3">Richiedi il buono sconto</h6>

                <div class="flash__form-input">
                  <p><b-form-input ref="name" required v-model="name" type="text" placeholder="Nome *"/></p>
                  <p><b-form-input ref="surname" required v-model="surname" type="text" placeholder="Cognome *"/></p>
                  <p><b-form-input ref="email" required v-model="email" type="email" placeholder="Email *"/></p>
                  <div class="flash__form-options">
                    <label class="d-block text-left">Scegli il buono sconto</label>
                    <ul class="mb-4">
                      <li>Scegli <strong>VadoBay livebooking</strong> per ricevere un buono da 50 € per prenotare alloggi.</li>
                      <li>Scegli <strong>Vacanze By VadoBay</strong> per ricevere un buono dal 100 € per pacchetti viaggio.</li>
                    </ul>
                    <div class="d-flex mb-2" >
                      <b-form-checkbox id="livebooking_50" ref="livebooking_50" v-model="checkboxLB" type="checkbox" name="checkbox" />
                      <label for="livebooking_50">
                        VadoBay livebooking (50€)
                      </label>
                    </div>
                    <div class="d-flex">
                      <b-form-checkbox id="vacanze_100" ref="vacanze_100" v-model="checkboxVV" type="checkbox" name="checkbox" />
                      <label for="vacanze_100">
                        Vacanze By VadoBay (100€)
                      </label>
                    </div>
                    <hr />
                  </div>
                </div>

                <div class="flash__form-checkbox">
                  <div class="d-flex">
                    <b-form-checkbox required id="checkboxTerms" ref="terms" v-model="checkboxTerms" type="checkbox" name="checkbox" />
                    <label for="checkboxTerms">
                      <router-link :to="{name: 'terms'}" target="_blank" class="nounderline">
                        <span>Accetto le condizioni d'uso</span>
                      </router-link>
                    </label>
                  </div>
                  <div class="d-flex">
                    <b-form-checkbox required id="checkboxPrivacy" ref="privacy" v-model="checkboxPrivacy" type="checkbox" name="checkbox" />
                    <label for="checkboxPrivacy">
                      <router-link :to="{name: 'privacy-policy'}" target="_blank" class="nounderline">
                        <span>Accetto le condizioni di Privacy</span>
                      </router-link>
                    </label>
                  </div>
                </div>

                <div class="flash__form-button">
                  <div v-if="!loading">
                    <div v-if="showButton">
                      <b-button v-if="recaptchaEnabled" :disabled="!validateFields()" @click="recaptcha">Richiedi</b-button>
                      <b-button v-else :disabled="!validateFields()" @click="sendRequest">Richiedi</b-button>
                    </div>
                  </div>
                  <Spinner v-else/>
                  <b-alert v-if="sentMsg" class="mt-4 text-center" variant="success" show>Richiesta inviata con successo.</b-alert>
                </div>
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <div class="flash__services">
              <h5 class="flash__title mb-5">Scopri tutti i nostri servizi di prenotazione viaggi sul portale welfare One flex Aon</h5>
            </div>
            <b-row>
              <b-col sm="12" lg="3">
                <div class="flash__services-item">
                  <a href="https://www.vadobay.com/" target="_blank">
                    <img alt="VadoBay Livebooking" src="assets/brands/livebooking.svg" />
                    <p class="flash__services-title">VadoBay livebooking</p>
                    <p class="flash__services-text">Le migliori proposte Expedia su centinaia di migliaia di hotel in Italia e nel mondo</p>
                  </a>
                </div>
              </b-col>
              <b-col sm="12" lg="3">
                <div class="flash__services-item">
                  <a href="https://booking.vadobay.com/" target="_blank">
                    <img alt="Vadobay in partnership with Booking.com" src="assets/brands/booking.svg" />
                    <p class="flash__services-title">VadoBay in partnership with Booking.com</p>
                    <p class="flash__services-text">Le migliori proposte di Booking.com con un focus speciale su appartamenti e bed&breakfast.</p>
                  </a>
                </div>
              </b-col>
              <b-col sm="12" lg="3">
                <div class="flash__services-item">
                  <a href="https://vacanze.vadobay.com/" target="_blank">
                    <img alt="Vacanze by VadoBay" src="assets/brands/vacanze.svg" />
                    <p class="flash__services-title">Vacanze by VadoBay</p>
                    <p class="flash__services-text">Francorosso, Edenviaggi, Turisanda, Alpitour, Bravo e molto altro. Il fantastico catalogo del gruppo Alpitour World per le tue vacanze.</p>
                  </a>
                </div>
              </b-col>
              <b-col sm="12" lg="3">
                <div class="flash__services-item">
                  <a href="https://voli.vadobay.com/" target="_blank">
                    <img alt="fly by VadoBay" src="assets/brands/flyby.svg" />
                    <p class="flash__services-title">fly by VadoBay</p>
                    <p class="flash__services-text">Le migliori compagnie low cost e centinaia di compagnie di linea per volare nel mondo.</p>
                  </a>
                </div>
              </b-col>
            </b-row>
            <b-row align-h="center" class="mt-5">
              <b-col lg="3">
                <div class="flash__services-item">
                  <a href="https://www.salabam.com" target="_blank">
                    <img alt="salabam un voucher per viaggiare" src="assets/brands/salabam.svg" />
                    <p class="flash__services-title">Salabam un voucher per viaggiare</p>
                    <p class="flash__services-text">I cofanetti viaggio digitali. Quelli facili da usare.</p>
                  </a>
                </div>
              </b-col>
              <b-col sm="12" lg="3">
                <div class="flash__services-item">
                  <img alt="Vivamod Hotels.com" src="assets/brands/hotels.svg" />
                  <p class="flash__services-title">Vivamod Hotels.com</p>
                  <p class="flash__services-text">Le migliori proposte di Hotels.com su centinaia di migliaia di hotel in Italia e nel mondo.</p>
                </div>
              </b-col>
              <b-col sm="12" lg="3">
                <div class="flash__services-item">
                  <a href="https://welfare.travel/" target="_blank">
                    <img alt="Welfare.Travel" src="assets/brands/welfare-travel.svg" />
                    <p class="flash__services-title">Welfare.Travel</p>
                    <p class="flash__services-text">Voli, treni, alloggi, esperienze e tanto altro per i tuoi viaggi col welfare aziendale</p>
                  </a>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-container>
    </div>
</template>

<script>
import Vue from 'vue'
import { VueReCaptcha } from 'vue-recaptcha-v3'
import Api from '../../../api'
import Spinner from '../../atoms/spinner'

export default {
  name: 'aon-flash',

  components: {
    Spinner,
  },

  props: {
  },

  data() {
    return {
      loading: false,
      name: '',
      surname: '',
      email: '',
      checkboxLB: false,
      checkboxVV: false,
      checkboxTerms: false,
      checkboxPrivacy: false,
      recaptchaEnabled: Vue.prototype.$config.recaptcha.enabled,
      recaptchaToken: '',
      sentMsg: false,
      showButton: true,
      submitterSettings: {
        type: 'form-aon-flash',
        label: 'aon-flash',
        recipient: Vue.prototype.$config.site.emailSupport,
      },
    }
  },

  mounted() {

    if(Vue.prototype.$config.recaptcha.enabled) {
      Vue.use(VueReCaptcha, { siteKey: Vue.prototype.$config.recaptcha.siteKey })
    }
  },

  methods: {

    async recaptcha() {
      this.loading = true

      // (optional) Wait until recaptcha has been loaded.
      await this.$recaptchaLoaded()
      // Execute reCAPTCHA with action "aon flash".
      const token = await this.$recaptcha('aonflash')
      // Do stuff with the received token.
      this.recaptchaToken = token
      this.sendRequest()
    },

    validateCoupon() {
      return this.checkboxLB || this.checkboxVV
    },

    validateFields() {
      if(Object.keys(this.$refs).length === 0) return false
      const fieldsValid = this.mixinValidateFields([
        {
          ref: this.$refs.name,
          type: 'firstName',
          value: this.name,
        },
        {
          ref: this.$refs.surname,
          type: 'lastName',
          value: this.surname,
        },
        {
          ref: this.$refs.email,
          type: 'email',
          value: this.email,
        },
        {
          ref: this.$refs.privacy,
          type: 'checkbox',
          value: this.checkboxPrivacy,
        },
        {
          ref: this.$refs.terms,
          type: 'checkbox',
          value: this.checkboxTerms,
        }
      ])

      return fieldsValid && this.validateCoupon()
    },

    sendRequest() {
      this.loading = true

      Api.formsSubmitter({
        recaptcha: this.recaptchaToken,
        fields: {
          subject: 'Promo Aon Flash',
          name: this.name,
          surname: this.surname,
          email: this.email,
          coupon: (this.checkboxLB ? 'livebooking 50€' : '') + ' ' + (this.checkboxVV ? 'vacanze 100€' : ''),
        },
        settings: this.submitterSettings
      })
      .then(
        (data) => {
          if(process.env.VUE_APP_MODE != 'production') window.console.log(data)
          if(process.env.VUE_APP_MODE != 'production') window.console.log(data.msg)
          this.loading = false
          this.sentMsg = true
          this.showButton = false

          if(this.$gtm) this.$gtm.trackEvent({
            event: 'customEvent',
            category: 'userBehaviour',
            action: 'formSubmit',
            label: this.submitterSettings.type,
            value: this.submitterSettings.label,
          })
        }
      )
    }
  },
}
</script>


<style lang="scss">

  .flash {
    display: block;
    width: 100%;
    max-width: 1440px;
    margin: 0 auto 100px;
    padding-top: 50px;

    @include media-breakpoint-up(lg) {
      padding-top: 250px;
    }

    &__title {
      color: $black;
    }

    &__logos {
      display: flex;
      align-items: flex-end;
      margin-top: 20px;

      img {
        width: 200px;
      }

      span{
        margin: 0 10px;
        font-size: $font-size-lg;
        font-weight:$font-weight-normal;
      }
    }

    &__content {

      &-title {
        margin: 40px 0 25px;
        font-weight:$font-weight-normal;
        color: $primary;
      }

      &-list {
        margin-left: 25px;

        li {
          margin-top: 25px;
        }

        &--decimal {
          li {
            list-style-type: decimal;
          }
        }
        &--disc {
          li {
            list-style-type: disc;
          }
        }
      }

      &-disclaimer {
        font-size: 14px;
      }
    }

    &__services {
      border-top: 1px solid #d5d9d9;
      padding-top: 50px;
      margin-top: 40px;

      &-title {
        font-weight: $font-weight-normal;
        font-size: 14px;
        line-height: normal;
        margin: 10px 0;
      }

      &-text {
        font-size: 14px;
        line-height: normal;
        margin-bottom: 0;
      }

      &-item {
        border-radius: 10px;
        padding: 15px;
        height: 100%;

        @include media-breakpoint-up(lg) {
          background-color: #fff;
        }

        img {
          height: 100px;
          padding: 10px 40px;
          display: block;
          margin: 0 auto;
        }

        a:link, a:visited {
          color: inherit;
        }
      }
    }

    &__form {
      padding-bottom: 2rem;
      max-width: 500px;
      margin-top: 60px;

      @include media-breakpoint-up(lg) {
        margin-top: 0;
      }

      &-options {
        margin: 40px 0;

        label {
          font-weight: $font-weight-normal;
        }

        ul {
          font-size: 14px;
          margin: 10px 0 20px 20px;


          li {
            margin: 10px 0;
            list-style-type: circle;

            strong {
              font-weight: $font-weight-normal;
            }
          }
        }

        select {
          font-size: 14px;
          font-weight: normal;
          background-color: #fff;
        }
      }

      &-button {
        margin-top: 20px;

        button {
          display: block;
          width: 100%;
        }
      }
    }
  }

</style>